import type { TickerEntry } from '../stores/tickerStore';
import type { QuoteFilter } from './quoteFilter';
import { QUOTE_FILTERS, symbolMatchesQuote } from './quoteFilter';

/**
 * The footer ticker bar can filter by quote asset OR by the user's
 * favourites. Extending QuoteFilter with 'FAV' keeps the filter row a flat
 * list of chips.
 */
export type FooterFilter = QuoteFilter | 'FAV';

export const FOOTER_FILTERS: FooterFilter[] = [...QUOTE_FILTERS, 'FAV'];

/**
 * Return true if the ticker passes the footer filter. For 'FAV', check the
 * symbol is in the provided favourites set.
 */
export function tickerMatchesFooterFilter(
  ticker: TickerEntry,
  filter: FooterFilter,
  favouriteSymbols: Set<string>,
): boolean {
  if (filter === 'FAV') return favouriteSymbols.has(ticker.symbol);
  return symbolMatchesQuote(ticker, filter);
}
